<template>
  <div>
    <div
      v-if="small"
      :class="[ link.component ? 'cPointer' : '' ]" @click="GoToLink()"
      :title="title"
      class="small-card-body"
      md="12"
    >
      <h5>
        <span class="small-card-label">{{label}}</span>
        <span class="small-card-value">{{value}}</span>
      </h5>
    </div>
    <d-card
      v-else
      :title="title"
      class="card stats-small stats-small--1 card card-small"
    >
      <d-card-body
        class="p-0 d-flex"
        :class="[ link.component ? 'cPointer' : '' ]"
        @click.native="GoToLink()"
      >
        <div class="d-flex flex-column m-auto">
          <div class="stats-small__data text-center">
            <span class="stats-small__label text-uppercase">{{ label }}</span>
            <h6 class="stats-small__value count my-3">{{ value }}</h6>
          </div>
        </div>
      </d-card-body>
    </d-card>
  </div>
</template>

<script>
export default {
  name: "cards",
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
    },
    value: {
      type: [Number, String],
      default: 0
    },
    small: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    link: {
      type: Object,
      default: function() {
        return {
          component: null,
          query: null
        }
      }
    }
  },
  methods: {
    GoToLink: function() {
      if (this.link.component) {
        this.$router.push({
          'name': this.link.component,
          'query': this.link.query
        })
      }
    }
  }
};
</script>

<style scoped>
.cPointer {
  cursor: pointer;
}
.small-card-body {
  background-color: #fff;
  width: 100%;
  height: 55px;
  padding: 1rem;
  margin-bottom: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);
}
.small-card-label {
  font-weight: 700;
}
.small-card-value {
  float: right;
}
</style>
<style lang="scss">
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .card-body {
    min-height: 140px;
    position: relative;
  }
  .stats-small canvas {
    left: 0;
  }
  .stats-small--1 .stats-small__data {
    align-items: center !important;
    padding-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/cards.vue